import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { AccessControl } from '@repo/sdk/models/components';

import { useGaiaClient } from '@/hooks/use-gaia-client';
import { getAccessControlQuery } from '@/queries/gaia-api/access-control';
import { GaiaQueryWithAgentId } from '@/queries/types';

export const useAccessControl = ({
  agentId,
}: GaiaQueryWithAgentId): UseQueryResult<AccessControl[] | undefined> => {
  const client = useGaiaClient();
  return useQuery(getAccessControlQuery({ agentId, client }));
};
